import React from 'react';
import { useTranslation } from 'react-i18next';
import { NavMenuItem, NavMenuDivider } from 'components/NavMenu';
import isAdmin from 'utils/session/isAdmin';
import getMyTeamsLink from './getMyTeamsLink';
import { NavMenuRouterLinkItem } from './NavMenuRouterLinkItem';
import { PLATFORM_ANNOUNCEMENTS_ROUTE } from 'utils/routes';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export function AdminAndManagerLinks() {
  var userIsAdmin = isAdmin();
  var myTeamsLink = getMyTeamsLink();
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [(userIsAdmin || myTeamsLink) && /*#__PURE__*/_jsx(NavMenuDivider, {}), userIsAdmin && /*#__PURE__*/_jsx(NavMenuItem, {
      as: "a",
      id: "admin_home_button",
      href: "/admin",
      children: t('navbar_admin')
    }), myTeamsLink && /*#__PURE__*/_jsx(NavMenuRouterLinkItem, {
      to: myTeamsLink,
      id: "my_teams_button",
      children: t('navbar_my_teams')
    }), userIsAdmin && /*#__PURE__*/_jsx(NavMenuRouterLinkItem, {
      id: "platform_announcements_button",
      to: PLATFORM_ANNOUNCEMENTS_ROUTE,
      children: t('navbar_platform_announcements')
    })]
  });
}